import { isMobile } from "../../../../helpers";

/**
 * Type definition for Stage Options. 
 * Using 'any' for the record if you don't have PIXI types installed, 
 * but Partial<PIXI.IRendererOptions> is the standard.
 */
interface StageSettings {
  resolution: number;
  transparent?: boolean;
  backgroundAlpha?: number;
  antialias?: boolean;
  autoDensity?: boolean;
  sharedTicker?: boolean;
  forceCanvas?: boolean;
  powerPreference?: 'high-performance' | 'low-power' | 'default';
}

export const stageOptions: StageSettings = isMobile()
  ? { 
      transparent: true, 
      backgroundAlpha: 0, 
      autoDensity: true,
      resolution: 2 
    }
  : {
      resolution: 1.5,
      antialias: true,
      autoDensity: true,
      backgroundAlpha: 0,
      transparent: true,
      sharedTicker: true,
      forceCanvas: false,
      powerPreference: 'high-performance',
    };